<template>
  <BlockLink
    :class="[buttonThemeClass, buttonSizeClass]"
    :label="label"
    :link="link"
    class="button"
  >
    <span>
      {{ label }}
    </span>
    <i class="icon icon--lg">
      <Icon name="fa6-solid:arrow-right" />
    </i>
  </BlockLink>
</template>

<script setup lang="ts">
import type { BlockButtonStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockButtonStoryblok
}>()

const link = computed(() => props.blok?.link?.cached_url)
const label = computed(() => props.blok?.label)
const theme = computed(() => props.blok?.theme)
const size = computed(() => props.blok?.size)
const buttonThemeClass = computed(() => 'button--' + theme.value)
const buttonSizeClass = computed(() => 'button--' + size.value)
</script>
